<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2"
      stroke="currentColor"
      class="w-4 h-4 transition-transform duration-200"
      :class="{ 'rotate-180': rotate }"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6" />
  </svg>
</template>

<script setup>
defineProps({
  rotate: {
    type: Boolean,
    default: false,
  },
});
defineOptions({ name: 'ChevronIcon' });
</script>
